import React from 'react';

import autoBind from 'react-autobind';
import { If, Then, Else } from 'react-if'
import { withTheme } from '@material-ui/core/styles';

// import other components within the same project here
import Config from "../../Config.jsx";

import Localization from "../../Localization.jsx"
import LocaleOverviewStage from "../../views/locale/LocaleOverviewStage.jsx"

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Card,
  CardContent,
  Divider,
  Typography,
} from '@material-ui/core';

class LocaleOverviewDialog extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      open: false,
      stageList: [],
      filePathDict: {},
      qaState: 0,
      is_share: 0,
    };
    autoBind(this);
  }

  close() {
    this.setState({ open: false });
    this.state.open = false;
  }

  handleClose() {
    this.close();
  }

  btnEditClicked() {
    this.handleClose();
    this.props.parent.editLocaleByLocaleId(this.props.root.state.targetLocaleData['id']);
  }

  btnCloseClicked() {
    this.handleClose();
  }

  refresh() {
    console.log(this.props.root.state.targetLocaleData);
    this.setState({
      filePathDict: {},
      qaState: this.props.root.state.targetLocaleData['qa_state'],
      is_share: this.props.root.state.targetLocaleData['is_share'],
    });
    let requestObj = {
      locale_id: this.props.root.state.targetLocaleData['id'],
    };
    this.props.root.refs.API.request("get_stage_list_by_locale_id", requestObj, this.getStageListOK, this.getStageListFailed);
  }

  getStageListOK(res) {
    let stageList = res.body['result'];
    this.setState({ stageList: stageList });

    let requestFileIdArr = [];
    for (let i = 0; i < stageList.length; i++) {
      let stage = stageList[i];
      for (let j = 0; j < stage.playback_list.length; j++) {
        let playback = stage.playback_list[j];
        let payload = JSON.parse(playback.payload);
        let fileId = payload['file_id'];
        if (fileId != null && parseInt(fileId) > 0) {
          requestFileIdArr.push(parseInt(fileId));
        }
      }
    }

    if (requestFileIdArr.length > 0) {
      let requestObj = {
        file_id_array: requestFileIdArr,
      };
      this.props.root.refs.API.request("get_path_by_file_id_array", requestObj, this.getFilePathArrayOK, this.getFilePathArrayFailed);
    }
  }

  getStageListFailed(err) {
    console.log("get stage list failed");
  }

  getFilePathArrayOK(res) {
    let dict = {};
    let pathArray = res.body['result'];
    for (let i = 0; i < pathArray.length; i++) {
      let filePath = pathArray[i];
      if (filePath['tn_path'] != "") {
        dict[filePath['id']] = filePath['tn_path'];
      }
      else {
        dict[filePath['id']] = filePath['path'];
      }
    }
    this.setState({ filePathDict: dict })
  }

  getFilePathArrayFailed(err) {
    console.log("get file path array failed");
  }

  qaStateClicked(qaState) {
    this.setState({ qaState: qaState });
    let requestObj = {
      locale_id: this.props.root.state.targetLocaleData['id'],
      qa_state: qaState,
    };
    this.props.root.refs.API.request("update_qa_state_by_locale_id", requestObj, this.updateQAstateOK, this.updateQAstateFailed);
  }

  updateQAstateOK(res){
    this.props.root.addNotification(Localization.strings.UPDATED);
    let localeId = res.body['result']['locale_id'];
    let qaState = res.body['result']['qa_state'];
    let localeData = this.props.parent.getLocaleDataById(localeId);
    localeData['qa_state'] = qaState;
    this.props.parent.updateLocalLocaleDataById(localeId, localeData);
  }

  updateQAstateFailed(err){
    console.log("update qa state failed");
  }

  setPrivateClicked(){
    // toggle is_share
    let requestObj = {
      locale_id: this.props.root.state.targetLocaleData['id'],
    };
    if(this.state.is_share == 0){
      this.props.root.refs.API.request("share_locale", requestObj, this.updateSetPrivateOK, this.updateSetPrivateFailed);
    }else{
      this.props.root.refs.API.request("unshare_locale", requestObj, this.updateSetPrivateOK, this.updateSetPrivateFailed);
    }
  }

  updateSetPrivateOK(res){
    this.props.root.addNotification(Localization.strings.UPDATED);
    let is_share_invert = this.state.is_share == 0? 1 : 0;
    this.setState({
      is_share: is_share_invert,
    });
    this.state.is_share = is_share_invert;

    let localeId = this.props.root.state.targetLocaleData['id'];
    let localeData = this.props.parent.getLocaleDataById(localeId);
    localeData['is_share'] = is_share_invert;
    this.props.parent.updateLocalLocaleDataById(localeId, localeData);
  }

  updateSetPrivateFailed(err){
    console.log("toggle is_share failed");
  }

  handleKeyPress = (event) => {
    if (this.props.root.isAdminUser()) {
      let key = parseInt(event.key);
      if (key >= 0 && key <= 3) {
        this.qaStateClicked(key);
      }
      if(key == 4){
        this.setPrivateClicked();
      }
    }
  }

  render() {
    return (
      <div>
        <Dialog
          fullWidth={true}
          maxWidth={'lg'}
          open={this.state.open}
          onClose={this.handleClose}
          onKeyPress={this.handleKeyPress}
        >
          <DialogTitle disableTypography={true}>
            <Typography variant="h6">
              {Localization.strings.OVERVIEW + " - " + this.props.root.state.targetLocaleData['locale_name']}
            </Typography>
            <If condition={this.props.root.isAdminUser()}>
              <Then>
                <span style={{position:'absolute', top:16, right:16}}>
                  <Button color={this.state.qaState == 0? "secondary":"default"} onClick={() => this.qaStateClicked(0)}>Unchecked (0)</Button>
                  <Button color={this.state.qaState == 1? "secondary":"default"} onClick={() => this.qaStateClicked(1)}>Checked (1)</Button>
                  <Button color={this.state.qaState == 2? "secondary":"default"} onClick={() => this.qaStateClicked(2)}>Minor (2)</Button>
                  <Button color={this.state.qaState == 3? "secondary":"default"} onClick={() => this.qaStateClicked(3)}>Major (3)</Button>
                  <Button color={this.state.is_share == 0? "secondary":"default"} onClick={() => this.setPrivateClicked()}>Set Private (4)</Button>
                </span>
              </Then>
            </If>
          </DialogTitle>
          <DialogContent dividers>
            <DialogContentText style={{
              backgroundColor: this.props.theme.palette.background.paper,
              padding: '24px',
              borderRadius: '12px',
              marginBottom: '24px',
              // border: `1px solid ${this.props.theme.palette.divider}`,
              fontSize: '1rem',
              lineHeight: '1.8',
              color: this.props.theme.palette.text.primary,
              boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
              position: 'relative'
            }}>
              <Typography variant="subtitle1" component="span" style={{
                fontWeight: 500,
                color: this.props.theme.palette.primary.main,
                marginRight: '8px'
              }}>
                {Localization.strings.DESCRIPTION + ":"}
              </Typography>
              <Typography component="span" style={{
                color: this.props.theme.palette.text.secondary
              }}>
                {this.props.root.state.targetLocaleData['description']}
              </Typography>
            </DialogContentText>
              <If condition={this.state.stageList.length == 0}>
                <Then>
                <Divider variant="middle"/>
                  <Card elevation={0}>
                    <CardContent>
                      Click the EDIT button to start creating stages.
                    </CardContent>
                  </Card>
                </Then>
              </If>
            {this.state.stageList.map( (row, i) => {
              return (
                <div key={i}>
                  <LocaleOverviewStage root={this.props.root} parent={this} stageData={row} />
                </div>
              );
            })}
          </DialogContent>
          <DialogActions style={{padding:'16px 24px'}}>
            <Button onClick={this.btnEditClicked}>{Localization.strings.EDIT}</Button>
            <Button
              onClick={this.btnCloseClicked}
              color="primary"
              variant="contained"
            >
              {Localization.strings.CLOSE}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

export default withTheme(LocaleOverviewDialog);
